<div soho-datagrid #SohoDataGrid
  [attr.id]="dataGridId"
  [attr.data-automation-id]="dataGridAutomationId"
  [gridOptions]="gridOptions"
  [emptyMessage]="emptyMessage"
  [ngClass]="htmlClasses"
  [dataset]="dataset"
  (cellchange)="onCellChange($event)"
  (rowAdd)="onRowAdd($event)"
  (closeFilterRow)="onCloseFilterRow($event)"
  (openFilterRow)="onOpenFilterRow($event)"
  (contextMenu)="onContextMenu($event)"
  (entereditmode)="onEnterEditMode($event)"
  (filtered)="onFiltered($event)"
  (keydown)="onKeyDown($event)"
  (rendered)="onRendered($event)"
  (rowActivated)="onRowActivated($event)"
  (rowDeactivated)="onRowDeactivated($event)"
  (rowClicked)="onRowClicked($event)"
  (rowDoubleClicked)="onRowDoubleClicked($event)"
  (selected)="onSelected($event)"
  (settingsChanged)="onSettingsChanged($event)"
  (sorted)="onSorted($event)"
  (filteroperatorchanged)="onFilterOperatorChanged($event)"
  (expandrow)="onExpandRow($event)"
  (collapserow)="onCollapseRow($event)"
></div>
